module.exports = "\n<div class=\"core\" >\n    <!--<md-spinner></md-spinner>-->\n    <md-grid-list cols=\"1\" class=\"grid\" rowHeight=\"fit\">\n        <md-grid-tile>\n            <div class=\"tile-right\">\n                <div class=\"white-block\" >\n                    <h1>Compte utilisateur</h1>\n\n                </div>\n\n            </div>\n\n        </md-grid-tile>\n        <div class=\"tile-inner\">\n\n        </div>\n    </md-grid-list>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/templates/users.component.html
// module id = 309
// module chunks = 0